import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("trq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("trq_token");
      localStorage.removeItem("trq_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STAGES = [
  "buyer",
  "sla",
  "sales_confirmation",
  "documentation",
  "voyage",
  "delivery",
  "closure",
];

export const STAGE_LABELS = {
  buyer: "Buyer Registration",
  sla: "Service Agreement",
  sales_confirmation: "Sales Confirmation",
  documentation: "Documentation & Voyage",
  voyage: "Voyage Details",
  delivery: "Delivery",
  closure: "Closure / Claim",
};

export const DOC_TYPES = [
  { key: "packing_list", label: "Packing List" },
  { key: "phytosanitary", label: "Phytosanitary Certificate" },
  { key: "certificate_of_origin", label: "Certificate of Origin" },
  { key: "psqir", label: "PSQIR" },
];

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Trigger a native browser download by navigating to a backend URL whose response carries
 * `Content-Disposition: attachment`. This is the most reliable cross-device pattern —
 * it works on iOS Safari (PDF viewer + share), Android Chrome (download manager),
 * desktop browsers, in-app browsers, and PWAs.
 *
 * Avoids unreliable patterns: blob URLs + <a download>, FileReader hacks, file-saver.
 *
 * @param {string} pathOrUrl  Either an absolute URL or a path starting with `/api/...`
 */
export function triggerNativeDownload(pathOrUrl) {
  const url = pathOrUrl.startsWith("http")
    ? pathOrUrl
    : `${BACKEND_URL}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;

  // Use a real anchor element with target="_blank" — the browser treats this as a
  // user-initiated navigation, which bypasses popup blockers more often than window.open
  // and lets iOS Safari open the PDF in its native viewer (with Share/Save to Files).
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  // `download` hint is honoured by Chrome/Edge/Firefox for same-origin attachment responses;
  // ignored on iOS but harmless.
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 2000);
}
